import { css } from '@emotion/react'
import { Button, Flow, Heading, Text } from 'bold-ui'
import { Box } from 'components/Box'

import { VisualizarTermoProfissionalButton } from './VisualizarTermoProfissionalButton'

interface SalaEsperaVideochamadaAnfitriaoFormProps {
  nomeProfissional: string
  cboProfissional: string | null
  handleEntrarButtonClick(): void
  onVisualizarTermo(): void
  isMobile?: boolean
}

export function SalaEsperaVideochamadaAnfitriaoForm(props: Readonly<SalaEsperaVideochamadaAnfitriaoFormProps>) {
  const { nomeProfissional, cboProfissional, handleEntrarButtonClick, onVisualizarTermo, isMobile = false } = props

  const identificacaoProfissional = cboProfissional ? `${nomeProfissional} | ${cboProfissional}` : nomeProfissional

  return (
    <Flow direction='vertical'>
      <Heading level={isMobile ? 4 : 2}>Acesso à chamada em andamento</Heading>
      <Box dataTestId='BoxAcessoChamada' style={isMobile && styles.boxMobile}>
        <div css={[styles.content, isMobile && styles.contentMobile]}>
          <Text style={styles.info}>
            Esta chamada já foi iniciada e está em andamento. Você entrará como
            <Text fontWeight='bold'>{` ${identificacaoProfissional}`}</Text>
          </Text>
          <Button
            kind='primary'
            onClick={handleEntrarButtonClick}
            data-testid='button.entrarVideochamada'
            style={isMobile && styles.fullWidth}
          >
            Entrar na chamada
          </Button>
        </div>
      </Box>
      <VisualizarTermoProfissionalButton onClick={onVisualizarTermo} isMobile={isMobile} />
    </Flow>
  )
}

const styles = {
  boxMobile: css`
    border: none;
    padding: 0;
  `,
  content: css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  `,
  contentMobile: css`
    flex-direction: column;
    align-items: stretch;
  `,
  info: css`
    flex: 1;
    min-width: 12rem;
  `,
  fullWidth: css`
    width: 100%;
  `,
}
